import React from 'react'
import SectionSwitcher from './SectionSwitcher'

/**
 * Renders SectionSwitcher from raw Drupal relationships data
 * This is a workaround for when gatsby-source-drupal fails to resolve relationships properly
 */
const RawSectionSwitcher = ({ rawData }) => {
  if (!rawData?.data) {
    return null
  }

  const sectionSwitcherData = rawData.data

  // Transform raw data into the expected SectionSwitcher format
  const transformedData = {
    id: sectionSwitcherData.id,
    title: sectionSwitcherData.attributes?.title,
    subtitle: sectionSwitcherData.attributes?.subtitle,
    items: sectionSwitcherData.relationships?.items?.data?.map((item) => ({
      id: item.id,
      title: item.attributes?.title,
      components: item.relationships?.components?.data?.map((component) => {
        // Transform component based on its type into the format SectionSwitcher expects
        const componentType = component.type.split('--')[1] // Remove "paragraph--" prefix
        console.log('Component:', component.relationships?.image?.data?.meta?.imageDerivatives?.links?.split_image_and_text_image_3xl)

        switch (component.type) {
          case 'paragraph--split_image_and_text':
            const imageData = component.relationships?.image?.data
            const imageUrl = imageData?.meta?.imageDerivatives?.links?.split_image_and_text_image_3xl ||
              imageData?.meta?.imageDerivatives?.links?.original ||
              imageData?.meta?.imageDerivatives?.fallback_image

            const transformedComponent = {
              type: 'split_image_and_text',
              content: {
                title: component.attributes?.title,
                content: component.attributes?.description?.processed,
                image: imageData ? {
                  variants: [{
                    url: imageUrl,
                    title: imageData.attributes?.filename || 'image.jpg',
                    style: 'default', // ResponsiveImage looks for 'default' style first
                    alt: imageData.meta?.alt || '',
                    height: imageData.meta?.height || null,
                    width: imageData.meta?.width || null
                  }]
                } : null
              }
            }
            return transformedComponent

          case 'paragraph--includes_excludes_list':
            return {
              type: 'includes_excludes_list',
              content: {
                listStyle: 'default',
                leftContent: {
                  title: component.attributes?.trip_includes_title || 'Inclusions',
                  items: component.attributes?.includes_item?.processed || ''
                },
                rightContent: {
                  title: component.attributes?.trip_excludes_title || 'Exclusions',
                  items: component.attributes?.excludes_item?.processed || ''
                }
              }
            }

          case 'paragraph--text':
            return {
              type: 'text',
              content: {
                title: component.attributes?.title,
                content: component.attributes?.text?.processed || ''
              }
            }

          case 'paragraph--two_column_text':
            return {
              type: 'two_column_text',
              content: {
                leftContent: {
                  title: component.attributes?.left_title || component.attributes?.title,
                  description: component.attributes?.left_content?.processed || component.attributes?.left_text?.processed || ''
                },
                rightContent: {
                  title: component.attributes?.right_title,
                  description: component.attributes?.right_content?.processed || component.attributes?.right_text?.processed || ''
                }
              }
            }

          case 'paragraph--weather_guide':
            // Transform weather data to match expected WeatherInfo structure
            const weatherItems = component.relationships?.weather_items?.data?.map((item) => ({
              title: item.attributes?.title || '',
              temperature_celsius: item.attributes?.temperature_celsius || '',
              temperature_fahrenheit: item.attributes?.temperature_fahrenheit || '',
              precipitation_metrics: item.attributes?.precipitation_metrics || '',
              precipitation_imperial: item.attributes?.precipitation_imperial || ''
            })) || []

            return {
              type: 'weather_guide',
              content: {
                items: weatherItems
              }
            }

          case 'paragraph--accordion':
            return {
              type: 'accordion',
              content: {
                title: component.attributes?.title,
                items: component.relationships?.accordion_items?.data?.map((item) => ({
                  title: item.attributes?.title,
                  text: item.attributes?.content?.processed || item.attributes?.text?.processed || ''
                })) || []
              }
            }

          default:
            console.warn(`Unknown component type: ${component.type}`)
            return {
              type: componentType,
              content: component.attributes || {}
            }
        }
      }) || []
    })) || []
  }

  return <SectionSwitcher {...transformedData} />
}

export default RawSectionSwitcher